module.exports = __webpack_public_path__ + "img/loading-dots-white.765fe614.gif";